import { env } from '@byted/ecom-mobile-lib';
import bridge from 'libs/bridge';
import { IAppInfo } from '@byted/ecom-mobile-lib/lib/types/bridge';

/**
 * @description 风控SDK呼起和关闭
 * @param callback 回调函数
 * @param error 错误处理函数
 */
export const renderRiskSDK = (option: {
    code: number;
    callback: Function;
    error: Function;
}): void => {
    const { code, callback, error } = option;

    const errorCallback = (err?: any) => {
        try {
            window.Slardar('emit', 'log', {
                value: JSON.stringify(window.renderCaptcha),
                tags: {
                    type: 'rendercaptcha error',
                    action: err
                }
            });
            error && error((err && err.msg) || '系统异常，请重试');
        } catch (error) {}
    };

    if (!window.renderCaptcha) {
        errorCallback();
        return;
    }

    const codeMap = {
        20205: 99999, // 滑块
        20206: 99998, // 点选
        20207: 99997, // 3d
        20208: 99996 // 旋转
    };

    const getUserInfo = (baseInfo: any) => {
        const baseIId = baseInfo && baseInfo.iid;
        bridge
            .call('appInfo', {}, { timeout: 500 })
            .then((res) => {
                const aid = (res as IAppInfo).aid || env.aid || 0;
                const params = {
                    aid: Number(aid),
                    iid: (res as IAppInfo).install_id || baseIId || '',
                    did: (res as IAppInfo).device_id || '0',
                    region: 'cn',
                    showMode: 'mask',
                    successCb: (res: any) => {
                        callback && callback(res);
                    },
                    challenge_code: codeMap[code] || 99999
                };
                console.warn('risk params', params);
                window.renderCaptcha(params);
            })
            .catch((err) => {
                error && error((err && err.msg) || '系统异常，请重试');
            });
    };

    const getInstallId = (callback: any) => {
        bridge
            .call('apiParam', {}, { timeout: 500 })
            .then((res) => {
                callback && callback(res);
            })
            .catch(errorCallback);
    };

    if (env.isInAweme || env.isInHotsoon) {
        // 如果是抖火的话，需要另外调用一个jsb获取iid
        getInstallId(getUserInfo);
    } else {
        getUserInfo({});
    }
};
